<template>
  <a :href="product.url" class="best-card">
    <div v-if="product.has_any_active_discount" class="discount-tag">
      <span>-{{ topDiscount }}%</span>
    </div>
    <div v-if="product.stock < 1" class="stock-tag">
      <span>{{ trans.get("wizard.outOfStock") }}</span>
    </div>
    <div class="best-card-image">
      <div class="best-card-image-content">
      <picture>
        <!-- webp url -->
        <source :srcset="product.images[0]?.webp || '/img/no-image-placeholder.png'" type="image/webp">
        <!-- Fallback to original format -->
        <img
          loading="lazy"
          :src="product.images[0]?.original || '/img/no-image-placeholder.png'"
          :alt="product.name[lang]"
        />
      </picture>

      </div>
    </div>
    <div class="card-text justify-between">
      <div>
        <div v-if="product.category" class="category-title" :class="product.category.slug['en']">
          {{ product.category.name[lang] || product.category.name.en }}
        </div>
        <h4>{{ product.name[lang] || product.name.en }}</h4>
      </div>
      <div>
        <hr />
        <div v-if="this.product.type == 'merch'" class="price flex flex-col lg:flex-row lg:items-center lg:gap-x-2 h-16 lg:h-auto">
          <p>
            {{ finalPriceMerch | currency }}
          </p>
          <span v-if="product.has_any_active_discount" class="line-through text-inactive-grey text-sm ml-1">{{ product.price | currency }}</span>
        </div>
        <div v-else class="price flex flex-col lg:flex-row lg:items-center lg:gap-x-2 h-16 lg:h-auto">
          <p class="mr-1">{{ trans.get("wizard.priceFrom") }} <span v-if="product.has_any_active_discount" class="line-through text-inactive-grey text-sm">{{ originalLowerPriceSeed | currency }}</span></p>
          <p>{{ finalLowerPriceSeed | currency }}/{{ trans.get("wizard.seed") }}</p>
        </div>
      </div>
    </div>
  </a>
</template>
<script>
import mixin from "@/js/mixin";
import { orderArrayPacksBySeedPrice } from "../../utils";

export default {
  mixins: [mixin],
  props: ["product"],
  computed:{
    topDiscount(){
      let discounts = this.product.packs.filter((pack) => pack.pivot.discount !== null).map((pack) => parseFloat(pack.pivot.discount));
      return Math.max(...discounts, this.product.discount);
    },
    finalPriceMerch(){
      return this.product.price - (this.product.price * this.product.discount / 100);
    },
    originalLowerPriceSeed(){
      const lowerPriceSeedPack = orderArrayPacksBySeedPrice(this.product.packs)[0];
      return parseFloat(lowerPriceSeedPack?.pivot.price) / lowerPriceSeedPack?.quantity;
    },
    finalLowerPriceSeed(){
      const lowerPriceSeedPack = orderArrayPacksBySeedPrice(this.product.packs)[0];
      return parseFloat(lowerPriceSeedPack?.pivot.final_price) / lowerPriceSeedPack?.quantity;
    }
  },
  mounted() {
  console.log("Stock en ProductCard:", this.product.stock);
}


};
</script>
<style lang="scss" scoped>
@import "../../../sass/_variables.scss";
.best-card {
  position: relative;
  max-width: 260px;
  width: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  //   height: 395px;

  @media(min-width: $breakpoint-landing-phone){
    max-height: 460px;
  }

  @media (min-width: 1024px) {
    width: 260px;
    // height: 466px;
    min-width: 260px;
  }

  &-image {
    position: relative;
    width: 100%;

    &:after {
      content: "";
      display: block;
      padding-bottom: 100%;
    }

    &-content {
      position: absolute;
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .discount-tag {
    z-index: 1;
    position: absolute;
    top: 3%;
    right: 5%;
    width: fit-content;
    height: 28px;
    background-color: #3a473c;
    color: white;
    font-size: 14px;
    font-weight: 900;
    border-radius: 8px;
    text-align: center;
    display: flex;
    align-items: center;

    span {
      padding: 4px 8px;
    }
  }

  .stock-tag {
    z-index: 1;
    position: absolute;
    top: 3%;
    left: 5%;
    width: fit-content;
    height: 28px;
    background-color: $inactive-grey;
    color: white;
    font-size: 14px;
    font-weight: 900;
    border-radius: 8px;
    text-align: center;
    display: flex;
    align-items: center;

    span {
      padding: 4px 8px;
    }
  }

  .card-text {
    padding: 1rem;
    height: 100%;
    display: flex;
    flex-direction: column;

    h4 {
      margin: 1rem 0;
      font-size: 18px;

      @media (min-width: 1024px) {
        font-size: 24px;
      }
    }

    .price {
      display: flex;
      margin-top: 1rem;

      @media (max-width: 1024px){
        margin: 0;
        justify-content: flex-end;
      }
    }
  }

  .category-title {
    padding: 2px 11px 1px;
    border-radius: 11.7px;
    border: solid 1px #a5ab90;
    color: white;
    font-size: 12px;
    font-weight: bold;
    width: fit-content;

    @media (min-width: 1024px) {
      font-size: 13px;
    }
  }

  .feminized-seeds {
    background-color: #a88ca8;
  }

  .autoflower-seeds {
    background-color: #a5ab90;
  }

  .seed-collective {
    background-color: #90abaa;
  }
}</style>
